import { FontName } from '@/components/Map/MapViewer/MapViewer.types';

const FONT_NAME_MAP: Record<FontName, string> = {
  ARIAL: 'Arial',
  HELVETICA: 'Helvetica',
  TIMES_NEW_ROMAN: 'Times New Roman',
  COURIER_NEW: 'Courier New',
  GEORGIA: 'Georgia',
  VERDANA: 'Verdana',
};

export function getFontName(fontNameEnum: FontName): string {
  const font = FONT_NAME_MAP[fontNameEnum];
  if (!font) {
    // eslint-disable-next-line no-console
    console.warn(`Unrecognized font name: "${fontNameEnum}", falling back to Arial`);
    return 'Arial';
  }
  return font;
}
